import { useState, useEffect } from 'react';

interface RoundTimer {
  label: string;
  timeLeft: number | null; // seconds, null = no limit
}

export function useRoundTimer(endTime: string | null | undefined): RoundTimer {
  const [timeLeft, setTimeLeft] = useState<number | null>(null);

  useEffect(() => {
    if (!endTime) {
      setTimeLeft(null);
      return;
    }
    const calc = () => Math.max(0, Math.ceil((new Date(endTime).getTime() - Date.now()) / 1000));
    setTimeLeft(calc());
    const id = setInterval(() => {
      const t = calc();
      setTimeLeft(t);
      if (t <= 0) clearInterval(id);
    }, 1000);
    return () => clearInterval(id);
  }, [endTime]);

  if (timeLeft === null) return { label: 'No time limit', timeLeft: null };
  const m = Math.floor(timeLeft / 60).toString().padStart(2, '0');
  const s = (timeLeft % 60).toString().padStart(2, '0');
  return { label: `${m}:${s}`, timeLeft };
}
